








































































































































































































import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';
import OrderingInterface from '@core/interfaces/ordering-interface';
import PaginationInterface from '@core/interfaces/pagination-interface';
import Avatar from 'vue-avatar';
import { FamilyMember } from '@contacts/interfaces/family-member';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { setProp } from '@shared/helpers/operators';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { ContactRelation } from '@contacts/interfaces/contact-relation';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import ContactForm from '@contacts/components/forms/contact-form/contact-form.vue';

@Component({
  name: 'bpc-family-relation-list-group-input',
  components: {
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-field-wrapper': FieldWrapper,
    'bpc-contact-form': ContactForm,
    'bpc-drawer-modal': DrawerModal,
    'bpc-std-form': StdForm,
    Avatar,
  },
})
export default class FamilyRelationListGroupInput extends mixins(AbstractField) {
  declare $refs: {
    familyRelationForm: InstanceType<typeof StdForm> & {
      saveEntity(): Promise<BPCGenericApiResponse>;
      formModel: any;
    };
    stdContactForm: InstanceType<typeof ContactForm> & {
      saveEntity(): Promise<BPCGenericApiResponse>;
    };
    deleteFamilyRelationConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
  };
  @Prop(Array) readonly value: object[];
  @Prop(Array) declare readonly filters: any[];

  get model(): object[] {
    return this.value;
  }
  set model(val: object[]) {
    this.$emit('input', val);
  }

  async mounted() {
    this.disabledFamilyRelationForm = this.disabled;
    await this.getFamiliesOrMembers();
    // this.$root.$on('relationCategoryChangedFromContactRelationForm', category => {
    //   this.setEmailValuesFromCategory(category);
    // });
  }

  destroyed() {
    // this.$root.$off('relationCategoryChangedFromContactRelationForm');
  }

  entityName = 'contact-relation';
  familyMembers: FamilyMember[] = [];
  loading: boolean = false;
  showFamilyRelationForm: boolean = false;
  disabledFamilyRelationForm: boolean = false;
  isSavingFamilyRelation: boolean = false;
  selectedFamilyRelationId: number = null;
  showContactForm: boolean = false;
  isSavingContactForm: boolean = false;
  disabledContactForm: boolean = false;
  editableContactId: number = null;

  // Ordering and pagination are not used for the moment
  ordering: OrderingInterface = {
    order_by: '',
    order_direction: 'desc',
  };
  pagination: PaginationInterface = {
    current_page: 1,
    last_page: 1,
    per_page: 5,
    from: 0,
    to: 0,
    total: 0,
  };

  get familyRelationFormConfigName(): string {
    return this.origin === 'family'
      ? 'family_relation_from_family'
      : 'family_relation_from_individual';
  }

  get saveFamilyRelationPath(): string {
    const url = this.$bpcApiRouteHelper.getEntityPath(this.entityName);
    return this.selectedFamilyRelationId
      ? `${url}/families/${this.selectedFamilyRelationId}`
      : `${url}/families`;
  }

  get fetchFamilyRelationPath(): string {
    return `${this.$bpcApiRouteHelper.getEntityPath(this.entityName)}/families/${
      this.selectedFamilyRelationId
    }`;
  }

  get deleteFamilyRelationPath(): string {
    return `${this.$bpcApiRouteHelper.getEntityPath(this.entityName)}/families`;
  }

  public get familyRelationConfigFileName(): string {
    return this.tenantType === 'center' ? 'contact_relation' : 'contact_relation_for_club';
  }

  public get contactConfigFileName(): string {
    return this.tenantType === 'center' ? 'contact' : 'contact_for_club';
  }

  get familyRelationTitleModal(): string {
    if (this.disabled) {
      return this.$t('global.modals_family_relation_title').toString();
    } else if (this.selectedFamilyRelationId) {
      return this.$t('global.modals_edit_family_relation_title').toString();
    } else {
      return this.$t('global.modals_create_family_relation_title').toString();
    }
  }

  get contactModalTitle(): string {
    return this.$t('global.modals.edit') + ' ' + this.$t('global.models.contact.name');
  }

  get familyOrMemberId() {
    // Depends on the origin, the ID belongs to a family or a member
    return this.formModel?.id;
  }

  get origin() {
    // Depends on the origin, it will be 'family' or 'individual'
    return this.formModel?.type || 'family';
  }

  get deleteFamilyRelationModalConfig() {
    return {
      id: this.entityName + '-soft-delete-modal-' + this.generateUUIDv4(),
      title: this.$t('global.modals.soft-delete.title', {
        entityName: this.$t('global.models.' + this.entityName + '.name'),
      }),
      body: this.$t('global.modals.soft-delete.body', {
        entityName: this.$t('global.models.' + this.entityName + '.name'),
      }) as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.move_to_trash') as string,
      acceptButtonVariant: 'danger',
    };
  }

  onInputCustomEvent($event) {
    if (
      $event.eventName === 'contactRelationCategory_changed' &&
      !!$event.item &&
      !!this.$refs.familyRelationForm?.formModel
    ) {
      // Email data
      setProp(
        this.$refs.familyRelationForm.formModel,
        'booking_emails',
        $event.item?.booking_emails || false,
      );
      setProp(
        this.$refs.familyRelationForm.formModel,
        'accounting_emails',
        $event.item?.accounting_emails || false,
      );
      setProp(
        this.$refs.familyRelationForm.formModel,
        'other_emails',
        $event.item?.other_emails || false,
      );
      // Settings of the relation
      setProp(
        this.$refs.familyRelationForm.formModel,
        'can_manage_organization',
        $event.item?.can_manage_organization || false,
      );
      setProp(
        this.$refs.familyRelationForm.formModel,
        'forward_own_messages_with_organization',
        $event.item?.forward_own_messages_with_organization || false,
      );
      setProp(
        this.$refs.familyRelationForm.formModel,
        'receive_organization_messages',
        $event.item?.receive_organization_messages || false,
      );
    }
  }

  onEditFamilyRelation(relationId: number) {
    this.selectedFamilyRelationId = relationId;
    this.showFamilyRelationForm = true;
  }

  onEditFamilyRelationFormButton() {
    this.disabledFamilyRelationForm = false;
  }

  onCloseFamilyRelationForm() {
    this.showFamilyRelationForm = false;
    this.isSavingFamilyRelation = false;
    this.selectedFamilyRelationId = null;
  }

  onDeleteFamilyRelation(relationId: number) {
    this.$refs.deleteFamilyRelationConfirmationModal.onOpenModal(relationId);
  }

  onSuccessDeleteFamilyRelation() {
    this.$refs.deleteFamilyRelationConfirmationModal.onCloseModal();
    this.getFamiliesOrMembers();
  }

  onErrorSavingFamilyRelation() {
    this.isSavingFamilyRelation = false;
  }

  generateUUIDv4() {
    return this.$bpcHelper.generateUUIDv4();
  }

  prepareFamilyRelationFormToSave(familyRelation: ContactRelation) {
    if (this.origin === 'family') {
      setProp(familyRelation, 'organization_contact_id', this.familyOrMemberId);
    } else {
      setProp(familyRelation, 'individual_contact_id', this.familyOrMemberId);
    }
    return familyRelation;
  }

  onSaveFamilyRelationForm() {
    this.isSavingFamilyRelation = true;
    this.$refs.familyRelationForm.saveEntity();
  }

  onFamilyRelationFormSaved() {
    this.getFamiliesOrMembers();
    this.onCloseFamilyRelationForm();
  }

  async getFamiliesOrMembers() {
    this.loading = true;
    const params = this.getQueryParams();
    const baseUrl = this.$bpcApiRouteHelper.getEntityPath('contact');

    let url: string;
    if (this.origin === 'family') {
      url = `${baseUrl}/family/${this.familyOrMemberId}/members`;
    } else {
      url = `${baseUrl}/family/${this.familyOrMemberId}/families`;
    }

    const res = await this.$bpcApi.get(`${url}`, { params: params }).toPromise();
    this.familyMembers = res.data;
    this.loading = false;
  }

  getQueryParams() {
    return {};
  }

  get tenantType(): string {
    return this.$store.getters['centerSettings/centerSettings']['center_type'] || 'center';
  }
  onAddFamilyRelation() {
    this.selectedFamilyRelationId = null;
    this.showFamilyRelationForm = true;
  }

  clickOnEditContact(member: FamilyMember) {
    this.editableContactId = member.contact_id;
    this.showContactForm = true;
  }
  onEditContactFormButton() {
    this.disabledContactForm = false;
  }
  onCloseContactForm() {
    this.showContactForm = false;
    this.isSavingContactForm = false;
    this.editableContactId = null;
  }
  onSaveContactForm() {
    this.isSavingContactForm = true;
    this.$refs.stdContactForm.saveEntity();
  }
  onContactFormSaved() {
    this.getFamiliesOrMembers();
    this.onCloseContactForm();
  }
  onContactSavingEntity(event) {
    this.isSavingContactForm = event;
  }
}
